import React from 'react'
import slugify from 'slugify'

import Image from '~/components/core/Image'

import { QuoteGradient } from '~/icons/QuoteGradient'
import { Quote } from '~/icons/Quote'
import {cn} from "~/utils/classnames";

const Testimony = ({
  data,
  isBiger = false,
  isPresentation = false,
  isIntro = false,
  isProject = false,
  isInText = false,
}) => {
  let theme = null

  data = data.fields ? data.fields : data

  if (data.theme) {
    theme = slugify(data.theme).toLowerCase()
  }

  const content = data.content.content ?? data.content
  return (
    <div
      className={cn(
          'row slice-bg',
          isProject ? 'slice-bg--project' : '',
          isInText ? '' : `slice-bg--${theme}`
      )}
    >
      <div
        className={`col-12 mx-auto ${!isProject ? `lg-col-10 ${isBiger ? 'xl-col-9' : 'xl-col-8'} ${!isPresentation ? 'lg-col-offset-1' : 'flex items-center'}` : ''} `}
      >
        <figure
          className={`testimony-slice ${isPresentation ? 'testimony-slice--pres' : ''}`}
        >
          <div className={`row ${!isProject ? 'lg:items-center' : ''}`}>
            <div
              className={`col-12 ${!isProject ? `md-col-4 ${isPresentation ? 'lg-col-4' : 'lg-col-3'} xl-col-4` : 'md-col-4 lg-col-2'} `}
            >
              {isIntro ? (
                  <Image
                      // classes="w-full"
                      classes="mx-auto"
                      width="400"
                      height="450"
                      sizes={{ 415: [354, 276], 767: [707, 552], 1023: [320, 257] }}
                      image={data.image}
                  />
              ) : (
                  <Image
                      classes="w-full"
                      width="640"
                      height="500"
                      sizes={{ 415: [354, 276], 767: [707, 552], 1023: [320, 257] }}
                      image={data.image}
                  />
              )}

            </div>

            <div
              className={`col-12 ${!isProject ? `md-col-8 lg-col-5 ${isBiger ? '' : 'xl-col-4'}` : 'md-col-8 lg-col-5 xl-col-4'}`}
            >
              <div className="row">
                <div className="col-12 md-col-1 lg-col-1">
                  {theme !== 'blue' ? (
                    <QuoteGradient className="icon" />
                  ) : (
                    <Quote className="icon" />
                  )}
                </div>

                <figcaption
                  className={`col-12 ${!isProject ? `md-col-7 lg-col-4 ${isBiger ? '' : 'xl-col-3'}` : 'md-col-7 lg-col-4 xl-col-3'}`}
                >
                  <blockquote
                    className={`testimony-slice__content ${theme !== 'purple' ? 'text-purple' : 'text-white'}`}
                  >
                    <p>{content}</p>
                  </blockquote>

                  <cite
                    className={`testimony-slice__cite ${theme === 'blue' ? 'text-white' : 'text-blue'}`}
                  >
                    {data.author}
                    <span
                      className={`block text-label ${isPresentation ? '' : 'mt-3 md:mt-0'}`}
                    >
                      {data.job}
                    </span>
                  </cite>
                </figcaption>
              </div>
            </div>
          </div>
        </figure>
      </div>
    </div>
  )
}

export default Testimony
